import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCheckoutSeatQuantity } from '@/redux/app/actions/organization';
import { orgCheckoutSeatQuantitySelector } from '../../../redux/app/selectors/organization';

export const AddSeats = () => {
  const dispatch = useDispatch();
  const seatQuantity = useSelector(orgCheckoutSeatQuantitySelector);
  const ref = React.useRef<HTMLInputElement>();
  const handleDecrement = () => {
    ref.current.stepDown();
    dispatch(setCheckoutSeatQuantity(ref.current.value));
  };
  const handleIncrement = () => {
    ref.current.stepUp();
    dispatch(setCheckoutSeatQuantity(ref.current.value));
  };

  return (
    <div className="body pa-20">
      <div className="flex justify-between">
        <div className="item-header">
          <p className="orange bold-900">Seats</p>
        </div>
        <div className="custom-number-input">
          <span
            role="button"
            tabIndex={0}
            onKeyPress={handleDecrement}
            onClick={handleDecrement}
          >
            -
          </span>
          <input
            ref={ref}
            className="number-input"
            type="number"
            min="1"
            max="10"
            value={seatQuantity}
          />
          <span
            role="button"
            tabIndex={0}
            onKeyPress={handleIncrement}
            onClick={handleIncrement}
          >
            +
          </span>
        </div>
      </div>
    </div>
  );
};
